<div modalHeader class="modal-header">
  <h2 class="my-2">Assign locations</h2>
  <tr-icon [icon]="icon.cancel" classes="close-btn pt-1" (click)="close()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <form [formGroup]="form">
    <div class="row" #nameSection>
      <div class="col form-group">
        <label for="user-email" class="control-label">User email</label>
        <input
          id="user-email"
          type="text"
          class="form-control"
          formControlName="email"
          placeholder="Enter user email"
        />
      </div>

      <div class="col form-group">
        <label for="user-name" class="control-label">User Full Name</label>
        <input
          id="user-name"
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="Enter user full name"
        />
      </div>
    </div>

    <div class="form-group" #rolesSection>
      <label class="control-label">Role</label>
      <tablesready-btn-group-control
        [items]="roles"
        bindName="name"
        bindValue="value"
        [control]="roleControl"
        [buttonType]="buttonColors.success"
      ></tablesready-btn-group-control>
    </div>

    <div *ngIf="locationsToDisplay.length > 0; else allLocationsSelected">
      <div class="form-group locations-list">
        <tablesready-checkbox-group
          [selectAll]="true"
          formControlName="locations"
          [items]="locationsToDisplay"
          searchTitle="Location"
          searchPlaceholder="Search locations"
          selectAllTitle="All locations"
        ></tablesready-checkbox-group>
      </div>
      <div *ngIf="!locationsControlValid">
        <p class="text-danger">Please, select at least 1 location</p>
      </div>
    </div>
  </form>
</div>

<div class="modal-actions mx-3" modalFooter>
  <div class="row">
    <div class="form-group col">
      <button
        ngbAutofocus
        class="btn btn-info w-100"
        [disabled]="!form.valid || !locationsControlValid || inProgress"
        (click)="sendInvite()"
      >Assign</button>
    </div>

    <div class="form-group col">
      <button class="btn btn-danger w-100" [disabled]="inProgress" (click)="close()">Cancel</button>
    </div>
  </div>
</div>

<ng-template #allLocationsSelected>
  <div class="d-flex flex-row justify-content-center">
    <p>This user is already assigned to all locations.</p>
  </div>
</ng-template>
